import React from "react";
import { ShoppingCart, Search, Menu, Heart } from "lucide-react";
import useStore from "../../store/useStore";

const Header = ({ currentPage, onNavigate }) => {
  const cart = useStore((state) => state.cart);
  const wishlist = useStore((state) => state.wishlist);

  const setCartOpen = useStore((state) => state.setCartOpen);
  const setSearchOpen = useStore((state) => state.setSearchOpen);
  const setMobileMenuOpen = useStore((state) => state.setMobileMenuOpen);

  const cartCount = cart.reduce((sum, item) => sum + item.quantity, 0);
  const wishlistCount = wishlist.length;

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40 border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center space-x-12">
            <button
              onClick={() => onNavigate("home")}
              className="text-3xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#1a1a3e] to-[#d4af37] cursor-pointer"
            >
              MAISON DE BIJOUX
            </button>
            <nav className="hidden lg:flex space-x-8">
              <button
                onClick={() => onNavigate("shop")}
                className={`${
                  currentPage === "shop" ? "text-[#d4af37]" : "text-gray-600"
                } hover:text-[#d4af37] transition font-medium`}
              >
                Collections
              </button>
              <button
                onClick={() => onNavigate("about")}
                className={`${
                  currentPage === "about" ? "text-[#d4af37]" : "text-gray-600"
                } hover:text-[#d4af37] transition font-medium`}
              >
                Our Story
              </button>
              <button
                onClick={() => onNavigate("contact")}
                className={`${
                  currentPage === "contact" ? "text-[#d4af37]" : "text-gray-600"
                } hover:text-[#d4af37] transition font-medium`}
              >
                Get in touch
              </button>
            </nav>
          </div>
          <div className="flex items-center space-x-6">
            <button
              onClick={() => setSearchOpen(true)}
              className="hidden sm:block p-2 hover:bg-[#e8e4f3] rounded-full transition"
            >
              <Search className="w-5 h-5 text-gray-600" />
            </button>
            <button
              onClick={() => onNavigate("wishlist")}
              className="hidden sm:block p-2 hover:bg-[#e8e4f3] rounded-full transition relative"
            >
              <Heart className="w-5 h-5 text-gray-600" />
              {wishlistCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-gradient-to-r from-red-500 to-red-600 text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {wishlistCount}
                </span>
              )}
            </button>
            <button
              onClick={() => setCartOpen(true)}
              className="p-2 hover:bg-[#e8e4f3] rounded-full relative transition"
            >
              <ShoppingCart className="w-5 h-5 text-gray-600" />
              {cartCount > 0 && (
                <span className="absolute -top-1 -right-1 bg-gradient-to-r from-[#d4af37] to-[#c49a2e] text-white text-xs rounded-full w-5 h-5 flex items-center justify-center font-medium">
                  {cartCount}
                </span>
              )}
            </button>
            <button
              onClick={() => setMobileMenuOpen(true)}
              className="lg:hidden p-2 hover:bg-[#e8e4f3] rounded-full transition"
            >
              <Menu className="w-5 h-5 text-gray-600" />
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
